import APITemplate from '@/api/APITemplate'

export default APITemplate('/equipment')
